const listeners = new Set();

const toastEmitter = {
  emit(message, type = 'info') {
    listeners.forEach(fn => fn({ message, type }));
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export default toastEmitter;
